import React, { useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import FloatingConsult from './components/FloatingConsult/FloatingConsult';
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import Projects from './pages/Projects/Projects';
import ProjectDetail from './pages/ProjectDetail/ProjectDetail';
import Platform from './pages/Platform/Platform';
import Notices from './pages/Notices/Notices';
import NoticeDetail from './pages/NoticeDetail/NoticeDetail';
import About from './pages/About/About';
import Careers from './pages/Careers/Careers';
import Contact from './pages/Contact/Contact';
import FAQ from './pages/FAQ/FAQ';

const scrollPositions = {};

const ScrollManager = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    // 公告详情之间切换始终回顶；列表等页面恢复上次滚动位置
    const isNoticeDetail = /^\/notices\/.+/.test(pathname);
    if (isNoticeDetail) {
      window.scrollTo(0, 0);
      delete scrollPositions[pathname];
    } else {
      const saved = scrollPositions[pathname];
      window.scrollTo(0, typeof saved === 'number' ? saved : 0);
    }

    html.style.scrollBehavior = prev;

    return () => {
      if (!/^\/notices\/.+/.test(pathname)) {
        scrollPositions[pathname] = window.scrollY || window.pageYOffset || 0;
      }
    };
  }, [pathname]);

  return null;
};

// 包装路由以支持动画
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/notices" element={<Notices />} />
        <Route path="/notices/:slug" element={<NoticeDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollManager />
        <Header />
        <AnimatedRoutes />
        <Footer />
        <FloatingConsult />
      </div>
    </Router>
  );
}

export default App;